/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { GenderDto } from './genderDto.schema';

export const IReadOnlyListOfGenderDto = zod.array(zod.lazy(() => GenderDto));

export type IReadOnlyListOfGenderDto = zod.input<typeof IReadOnlyListOfGenderDto>;
export type IReadOnlyListOfGenderDtoOutput = zod.output<typeof IReadOnlyListOfGenderDto>;
